import { render } from "./PasarelaPublica.vue?vue&type=template&id=7029532a&scoped=true"
import script from "./PasarelaPublica.vue?vue&type=script&lang=js"
export * from "./PasarelaPublica.vue?vue&type=script&lang=js"

import "./PasarelaPublica.vue?vue&type=style&index=0&id=7029532a&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7029532a"]])

export default __exports__